

export const HowItWorks = () => {
    return (
        <div className="reasons-container flx-col">
            <div className="reason-box">
                <div className="reason-cap">
                    <div className="reason-txt blk">So Arbeiten</div>
                    <div className="reason-txt sec-col">Wir?</div>
                </div>
                <div style={{marginBlock: 8}}></div>
                <div className="flx-col how-text">
                   Wir stehen für diskrete und zuverlässige Arbeit mit persönlichem Service. Ohne Callcenter – Sie sprechen direkt mit uns. Sowohl in Berlin als auch in Brandenburg sind wir schnell vor Ort, egal an welcher Ecke.Wir prüfen/rechnen und unterbreiten schließlich entsprechende, transparente Angebote ohne versteckte Kosten
                </div>
            </div>
        </div>
    )
}